import { render, staticRenderFns } from "./LogManagementView.vue?vue&type=template&id=3b7818fe&"
import script from "./LogManagementView.vue?vue&type=script&lang=js&"
export * from "./LogManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports